import qs from 'qs'
import axios from '@/api/apiClient'
/**
 * 上传文件api
 */
const api = {
  // 获取上传路径{ bizkey } 业务key: moxing-存放模型的文件(不包括预览图);identity-存放身份证等重要资料;poster-存放海报和作品的所有文件;image-存放其他文件
  uploadBefore: '/api/complex/myupload',
  Mydown: '/api/complex/myupload/mydown',
}
// const getRandomInt = (max)=> {
//   return Math.floor(Math.random() * Math.floor(max));
// }
export default api
/**
 * 获取上传路径
 * @param {*} bizkey 业务key: moxing-存放模型的文件(不包括预览图);identity-存放身份证等重要资料;poster-存放海报和作品的所有文件;image-存放其他文件;protectionopen-存放加水印且原图保护的文件(例如营业执照)
 * @param {*} fileName 文件名称 非必填,不填要自己生成key
 */
export const initUploadTask = async (bizkey, fileName) => {
  console.log('initUploadTask', bizkey, fileName)
  const upload = await axios.$get(`${api.uploadBefore}/${bizkey}?filename=${encodeURIComponent(fileName)}`)
  // 兼容旧代码调用问题,2020年9月15日14:42:29之后 传fileName到初始化接口para将会带上key值
  if (upload.code === 0 && upload.data && upload.data.para && fileName) {
    if (!upload.data.filename) {
      upload.data.filename = fileName
    }

    if (!upload.data.para.key) {
      upload.data.para.key = `${upload.data.para.dir}/${upload.data.filename || fileName}`
    }
  }
  return upload
}

// 获取oss加密图片地址
export const getFileAccess = (query) => {
  return axios.$get(`${api.Mydown}${query ? `?${qs.stringify(query)}` : ''}`)
}

export const getUploadData = (bizkey, query) => {
  return axios.$get(`${api.uploadBefore}/${bizkey}${query ? `?${qs.stringify(query)}` : ''}`)
}
